'use client';

import React__default, { useReducer, useMemo, useEffect } from 'react';
import { CascaderWrapper } from './Cascader.css.js';
import { cascaderReducer, CascaderContext } from './context/reducer.js';
import { initialCascaderState } from './context/index.js';
import translations from './translations.js';
import InputContainer from './components/InputContainer/index.js';
import { mergeProps } from './helper.js';
import DropdownContainer from './components/DropdownContainer/index.js';
import '../_virtual/_tslib.js';
import useFloating from '../hooks/useFloating/index.js';
import useClickAway from '../hooks/useClickAway.js';
import '../hooks/useMakeSearchable/types.js';
import '../Utils/constants.js';
import { isLocationChanged } from '../Utils/helpers.js';
import '../services/resumes/types.js';
import { ACTIONS } from './context/actions.js';

var Cascader = function (props) {
    var _a = useReducer(cascaderReducer, initialCascaderState), state = _a[0], dispatch = _a[1];
    var mergedProps = useMemo(function () { return mergeProps(props); }, [props]);
    var floatingConfig = mergedProps.floatingConfig;
    var useFloatingResult = useFloating({
        placement: floatingConfig.placement,
        position: floatingConfig.position,
        config: {
            useWindowAsFlippingContainer: floatingConfig.useWindowAsFlippingContainer,
            isFlip: floatingConfig.isFlip,
            detectHidden: true
        }
    });
    var refs = useFloatingResult.refs;
    useClickAway(function () {
        if (!state.isShow) {
            return;
        }
        dispatch({
            type: ACTIONS.ON_CANCEL
        });
        mergedProps.onBlur && mergedProps.onBlur();
    }, {
        nodeRefs: [refs.popup, refs.reference]
    });
    var t = function (text) {
        var _a;
        if (props.langCode === 'en') {
            return text;
        }
        else {
            return (_a = translations[text]) !== null && _a !== void 0 ? _a : text;
        }
    };
    useEffect(function () {
        // isLocationChanged is using for compare variable that have type TNestedGenericId[]
        var isValueChanged = isLocationChanged(state.value, props.value);
        if (!isValueChanged) {
            return;
        }
        dispatch({
            type: ACTIONS.SET_VALUE_FROM_PROP,
            payload: props.value
        });
    }, [props.value]);
    return (React__default.createElement(CascaderContext.Provider, { value: {
            state: state,
            props: mergedProps,
            t: t,
            dispatch: dispatch
        } },
        React__default.createElement(CascaderWrapper, { isFlex: mergedProps.styleOptions.isFlex },
            React__default.createElement(InputContainer, { ref: refs.setReference }),
            React__default.createElement(DropdownContainer, { floatingState: useFloatingResult }))));
};

export { Cascader as default };
//# sourceMappingURL=index.js.map
